import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="cases" routeLang="en" />;

export const Route = createFileRoute("/en/real-cases/")({
  head: () => publicToolHead("cases", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
